import { Fire, Lightning, Calendar, ArrowsClockwise } from "@phosphor-icons/react";

const CONFIG = {
    hoy:         { icon: Fire,           color: "text-red-700 bg-red-50 border-red-200",          label: "🚨 Hoy" },
    semana:      { icon: Lightning,       color: "text-[#8a5e10] bg-[#E8A33A]/15 border-[#E8A33A]/40", label: "⚡ Esta semana" },
    mes:         { icon: Calendar,        color: "text-[#2E7D32] bg-[#2E7D32]/10 border-[#2E7D32]/30", label: "📅 Este mes" },
    recurrente:  { icon: ArrowsClockwise, color: "text-blue-700 bg-blue-50 border-blue-200",     label: "🔄 Compra recurrente" },
};

const ADMIN_LABEL = {
    hoy: "🚨 Today",
    semana: "⚡ This week",
    mes: "📅 This month",
    recurrente: "🔄 Recurring purchase",
};

export default function UrgencyBadge({ urgency, admin = false }) {
    const c = CONFIG[urgency] || CONFIG.mes;
    return (
        <span className={`inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full border ${c.color}`}
            data-testid={`urgency-${urgency}`}>
            {admin ? (ADMIN_LABEL[urgency] || ADMIN_LABEL.mes) : c.label}
        </span>
    );
}
